import type { SVGProps } from 'react';
import * as React from 'react';

const DgnIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/dgn">
      <g id="Vector" filter="url(#filter0_dd_3816_37994)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_37994)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2224 7.44444C26.2224 8.9172 27.4163 10.1111 28.8891 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="#F3F4F6"
        />
      </g>
      <g id="Vector_2">
        <path
          d="M24.6562 24.3937C24.606 24.2786 24.5714 24.2037 24.5662 24.1838V24.1786C24.246 23.4534 23.9414 22.7737 23.6463 22.1484C23.6066 22.0584 23.5616 21.9684 23.5213 21.8784C23.4711 21.7685 23.4213 21.6634 23.3711 21.5582C22.1614 18.9682 21.2462 17.3131 20.6513 16.6182C20.5163 16.4581 20.3263 16.388 20.1113 16.388C19.8962 16.388 19.7063 16.4581 19.5713 16.6182C18.9763 17.3131 18.0612 18.9682 16.8514 21.5582C16.8012 21.6634 16.7515 21.7681 16.7013 21.8784C16.6615 21.9684 16.6165 22.0584 16.5762 22.1484C16.2811 22.7732 15.9761 23.4534 15.6563 24.1786V24.1838C15.6511 24.2037 15.6165 24.279 15.5663 24.3937C15.294 25.009 14.5096 26.799 14.1543 27.5976L14.7819 27.349C15.5573 27.0306 16.346 26.7332 17.1271 26.4556L17.1432 26.4485C17.2081 26.2884 17.5217 25.4883 17.5818 25.3335C17.732 24.9583 17.8769 24.5983 18.0167 24.2535C18.0318 24.2236 18.0418 24.1886 18.0565 24.1583C18.2066 23.7883 18.3516 23.4331 18.4913 23.0982C18.5211 23.0233 18.5562 22.9532 18.5865 22.8784C18.6367 22.7633 18.6817 22.6534 18.7267 22.5435C18.8016 22.3687 18.8717 22.2034 18.9366 22.0433C19.0213 21.8481 19.1014 21.6634 19.1814 21.4834C19.3164 21.1783 19.4363 20.9036 19.5414 20.6635C19.5812 20.5682 19.6262 20.4783 19.6613 20.3935C19.7863 20.1183 19.8863 19.8985 19.9663 19.7284C20.0379 19.5683 20.0862 19.4641 20.1113 19.4111C20.1364 19.4646 20.1847 19.5693 20.2562 19.7284C20.3363 19.8985 20.4362 20.1183 20.5613 20.3935C20.5963 20.4783 20.6413 20.5682 20.6811 20.6635C20.7863 20.9036 20.9061 21.1783 21.0411 21.4834C21.1212 21.6634 21.2012 21.8486 21.286 22.0433C21.3509 22.2034 21.421 22.3682 21.4958 22.5435C21.5408 22.6534 21.5858 22.7633 21.636 22.8784C21.6659 22.9532 21.7009 23.0233 21.7313 23.0982C21.8715 23.4331 22.0164 23.7883 22.1661 24.1583C22.1813 24.1881 22.1912 24.2232 22.2059 24.2535C22.3461 24.5983 22.491 24.9583 22.6407 25.3335C22.7009 25.4883 23.0145 26.2884 23.0793 26.4485L23.0955 26.4556C23.8765 26.7332 24.6647 27.0306 25.4406 27.349L26.0683 27.5976C25.713 26.799 24.9286 25.009 24.6562 24.3937Z"
          fill="#BA0028"
        />
        <path
          d="M16.5158 29.1987C16.1506 31.0285 16.1108 32.8886 16.1108 32.8886L14.6107 33.8886H12.1106L13.5956 29.1987H16.5158Z"
          fill="#BA0028"
        />
        <path
          d="M16.1255 29.1987C15.6154 30.6638 15.0706 32.3235 14.6107 33.8886H12.1106L13.5956 29.1987H16.1255Z"
          fill="#E04F5F"
        />
        <path
          d="M28.1105 33.8885H25.6104L24.1103 32.8885C24.1103 32.8885 24.0502 29.9484 23.3605 27.8235C23.3553 27.8036 23.3453 27.7837 23.3406 27.7633H26.1703L28.1105 33.8885Z"
          fill="#BA0028"
        />
        <path
          d="M28.1105 33.8885H25.6104C24.9805 31.7385 24.2757 29.6585 23.5803 27.7785C23.5803 27.7785 23.5803 27.7733 23.5751 27.7633H26.1699L28.1105 33.8885Z"
          fill="#E04F5F"
        />
        <path
          d="M24.776 24.6243L24.606 24.2392L24.1977 24.341C22.1779 24.844 18.3373 25.8885 14.7819 27.3484L14.1581 27.5961L14.0766 27.797C13.7422 28.5866 13.4286 29.3378 13.1411 30.0313L13.7365 29.8882C13.7365 29.8882 16.8613 29.0134 25.6737 27.8884L26.1568 27.8225C25.7191 26.7899 25.2511 25.7014 24.776 24.6243Z"
          fill="#BA0028"
        />
        <path
          d="M28.1109 33.8884L29.1109 33.3887C29.1109 33.3887 28.6059 30.7285 27.5259 26.9339C26.4611 23.1937 24.8459 18.3589 22.611 13.8893H17.6109C15.3761 18.3594 13.7608 23.1942 12.696 26.9339C11.616 30.7285 11.1111 33.3887 11.1111 33.3887L12.111 33.8889C12.111 33.8889 13.1673 31.2259 14.5367 27.993C18.2452 26.4233 22.4192 25.3002 24.3187 24.8265C26.2839 29.281 28.1109 33.8884 28.1109 33.8884ZM15.1516 26.5526C16.8691 22.5642 18.877 18.1988 19.931 16.9639C19.9774 16.9094 20.0466 16.8891 20.111 16.8891C20.1754 16.8891 20.2446 16.9094 20.291 16.9634C20.9366 17.7194 21.9389 19.6482 23.0132 21.9461L15.1516 26.5526Z"
          fill="#D92949"
        />
        <path
          d="M21.1109 13.8889C21.1109 13.8889 24.8259 19.3888 27.5107 26.8885C27.5159 26.9037 27.5207 26.9184 27.5259 26.9335C26.4611 23.1934 24.8458 18.3585 22.611 13.8889H21.1109Z"
          fill="#E04F5F"
        />
        <path
          d="M19.1108 13.8889C19.1108 13.8889 15.3958 19.3888 12.7109 26.8885C12.7057 26.9037 12.701 26.9184 12.6958 26.9335C13.7606 23.1934 15.3759 18.3585 17.6107 13.8889H19.1108Z"
          fill="#BA0028"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_37994"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_37994" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_37994" result="effect2_dropShadow_3816_37994" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_37994" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_37994"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.03} />
      </radialGradient>
    </defs>
  </svg>
);
export default DgnIcon;
